// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2fsUE","list":"PatternAutocomplete_list__3LQXu"};